// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { isCustomQuoteRequired } from "@store/Framework/Common/Utilities/productUtilities";
import AskForQuoteLink, { AskForQuoteLinkStyles } from "@store/Library/Components/AskForQuote/AskForQuoteLink";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsAskForQuoteLinkStyles {
    wrapper?: InjectableCss;
    link?: AskForQuoteLinkStyles;
}

export const askForQuoteLinkStyles: ProductDetailsAskForQuoteLinkStyles = {
    wrapper: {
        css: css`
            margin-top: ${pxToRem(30)};
            text-align: center;
        `,
    },
};

const styles = askForQuoteLinkStyles;

const ProductDetailsAskForQuoteLink: React.FC<Props> = ({ product }) => {
    if (!product || (product && !isCustomQuoteRequired(product))) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <AskForQuoteLink extendedStyles={styles.link} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsAskForQuoteLink),
    definition: {
        displayName: "Ask For Quotes Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
